import { Component, Fragment, h, Prop } from '@stencil/core';
import { ShippingItem } from '../../../redux/types';
import { StaticCartArticle } from '../../rentware-cart/rentware-cart-article/interfaces';
import { PriceCalculation } from '../../../types/types';
import { t } from '../../../redux/utils';

@Component({
  tag: 'rtr-step-payment-articles',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrStepPaymentArticles {
  @Prop() articles?: StaticCartArticle[];
  @Prop() shipping?: ShippingItem;
  @Prop() allowTotalPrice: boolean;

  get shippingArticle(): StaticCartArticle {
    if (!this.shipping) {
      return null
    }

    return {
      id: `${this.shipping.optionId}-${this.shipping.method}`,
      itemId: '',
      articleText: '',
      image: null,
      isVariation: false,
      priceCalculationType: PriceCalculation.Interval,
      articleTitle: this.shipping.name,
      includedArticles: [],
      connectedArticles: [],
      itemAmount: 1,
      totalPrice: this.shipping.price,
      price: this.shipping.price,
    };
  }

  render() {
    return (
      <Fragment>
        <rentware-spacer size="S" />

        <div class="DateWrapper">
          <span>{t('details.booking')}</span>
          <rentware-date-output size="M" />
        </div>

        <rentware-spacer size="S" />

        {this.articles.map(article => {
          return <rtr-cart-article-static key={article.itemId} article={article} allowTotalPrice={this.allowTotalPrice} />;
        })}

        {this.shipping && (
            <rtr-cart-article-static key={this.shipping.optionId} article={this.shippingArticle} allowTotalPrice={this.allowTotalPrice} />
        )}
      </Fragment>
    );
  }
}
